import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CustomFieldService } from 'src/app/profiles/shared/custom-field.service';
import { CustomFieldDataTypeEnum } from 'src/app/profiles/shared/enum/custom-field-data-type.enum';
import { CustomFieldDisplayTypeEnum } from 'src/app/profiles/shared/enum/custom-field-display-type.enum';
import { CustomFieldMetadataLego } from '../../shared/dto/custom-field-metadata.lego';

@Component({
  selector: 'wl-custom-field-lego-summary',
  templateUrl: './custom-field-lego-summary.component.html',
  styleUrls: ['./custom-field-lego-summary.component.less'],
    standalone: false
})
export class CustomFieldLegoSummaryComponent implements OnInit, OnChanges {
  @Input() customFieldData: CustomFieldMetadataLego;
  customFieldType: CustomFieldDataTypeEnum;
  customFieldDisplayType: CustomFieldDisplayTypeEnum;
  customFieldDateTypes = CustomFieldDataTypeEnum;
  customFieldDisplayTypes = CustomFieldDisplayTypeEnum;

  constructor(private customFieldService: CustomFieldService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customField) {
      if (this.customFieldData.CustomFieldId) {
        this.customFieldService.get(this.customFieldData.CustomFieldId).then((data) => {
          this.customFieldDisplayType = this.getDisplayType(data.DisplayType.toLowerCase());
          this.customFieldType = CustomFieldDataTypeEnum[data.DataType];
        });
      }
    }
  }

  private getDisplayType(displayTypeName: string): CustomFieldDisplayTypeEnum {
    switch (displayTypeName) {
      case 'textbox - multiline':
        return CustomFieldDisplayTypeEnum.TextboxMultiline;
      case 'drop down list':
        return CustomFieldDisplayTypeEnum.DropDownList;
      default:
        return CustomFieldDisplayTypeEnum.TextboxSingleline;
    }
  }
}
